import {BarChart} from '@/_metronic/partials/content/chart/BarChart'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {useGetRevenueServiceSharingWib} from '../core/_query'
import {useMemo} from 'react'

const RevenueSharingWib = () => {
  const {state} = useQueryRequest()
  const {data: revenueWib, isLoading} = useGetRevenueServiceSharingWib(state)

  const arrData = useMemo(() => {
    return revenueWib?.response?.data || []
  }, [revenueWib])

  const labels = useMemo(() => {
    return arrData?.map((x) => x.periode || '')
  }, [arrData])

  const revenueOutlet = useMemo(() => {
    return arrData?.map((x) => x.service_share_outlet || 0)
  }, [arrData])

  const revenuePartner = useMemo(() => {
    return arrData?.map((x) => x.service_share_partner || 0)
  }, [arrData])

  return (
    <BarChart
      className='mt-10 area-wib shadow-wit'
      color='info'
      title='Revenue & Service Sharing'
      subtitle='Area WIB'
      height='400px'
      series={[
        {
          name: 'Outlet',
          data: revenueOutlet,
        },
        {
          name: 'Hotel',
          data: revenuePartner,
        },
      ]}
      categories={labels}
      total={0}
      isTotal={false}
      data={arrData?.map((x) => ({
        month: x.periode,
        total_share_outlet: x.total_share_outlet,
        revenue_share_outlet: x.revenue_share_outlet,
        service_share_outlet: x.service_share_outlet,
        total_share_partner: x.total_share_partner,
        revenue_share_partner: x.revenue_share_partner,
        service_share_partner: x.service_share_partner,
      }))}
      headers={[
        'Periode',
        'Total Sharing Outlet',
        'Revenue Sharing Outlet',
        'Service Sharing Outlet',
        'Total Sharing Partner',
        'Revenue Sharing Partner',
        'Service Sharing Partner',
      ]}
      formatCurrency={[
        'total_share_outlet',
        'revenue_share_outlet',
        'service_share_outlet',
        'total_share_partner',
        'revenue_share_partner',
        'service_share_partner',
      ]}
      isLoading={isLoading}
    />
  )
}

export {RevenueSharingWib}
